import App from './App.vue'
import { Vue, i18n, router, store } from './main-common'
import { openInit } from './init'
import currency from '@/utils/currency'
import SodaMasMonitor from '@didi/soda-mas-monitor'
import { omega } from '@/lib/omega'

initialize([
  currency.init(), // 50ms 延时
]).then(() => {
  init()
})
function init() {
  openInit().then(() => {
    // eslint-disable-next-line no-new
    new SodaMasMonitor({
      env: process.env.NODE_ENV,
      Omega: omega,
      openTestTrack: true,
    })
    new Vue({
      i18n,
      router,
      store,
      mounted() {
        // 在应用挂载完成后触发自定义事件
        window.dispatchEvent(new CustomEvent('soda-mas-monitor-app-mounted'))
      },
      render: h => h(App),
    }).$mount('#app')
  })
}

function initialize(promiseArr) {
  return Promise.all(promiseArr)
}
